import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {DISPATCHER_PREFIX} from "../../consts/data-service-consts";

const CREATIVE_TYPE_URL = DISPATCHER_PREFIX + '/creative-types';

@Injectable({
    providedIn: 'root'
})
export class MxCreativeTypeService {

    public static getThumbnailUrl(id: number): string {
        return `${CREATIVE_TYPE_URL}/${id}/thumbnail`;
    }

    public static getUploadUrl(id: number): string {
        return `${CREATIVE_TYPE_URL}/${id}/thumbnail/upload`;
    }

    public static getDefaultThumbnailClass(name: string): string {
        switch (name) {
            default:
            case 'Banner':
            case 'Logos':
            case 'Dynamic Banner' :
                return 'camera_enhance';
            case 'Flash' :
                return 'play_circle_filled';
            case 'Generic Tracker' :
                return 'link';
            case 'Tracking Code':
            case 'HTML' :
                return 'code';
            case 'Text' :
                return 'description';
            case 'WAP':
            case 'Video' :
                return 'videocam';
        }
    }

    constructor(private httpClient: HttpClient) {
    }

    public resetThumbnail(id: number): Observable<void> {
        return this.httpClient.put<void>(`${CREATIVE_TYPE_URL}/${id}/thumbnail/reset`, {});
    }
}
